module.exports = "<div class=\"map-gallery\">\n  <div class=\"image-wrapper\">\n    <div class=\"image\" style=\"background: url('{{vm.photos.images[vm.photos.selIndex].photoURLHQ}}');\">\n      <div class=\"content\">\n        <img src={{vm.mapimage}}>\n      </div>\n      <div class=\"loading\" ng-if=\"vm.loading\">Loading...</div>\n      <div class=\"loading\" ng-if=\"vm.error\">Image file is missing.</div>\n    </div>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/mapGallery/mapGallery.html
 ** module id = 237
 ** module chunks = 0
 **/